import { Box, Typography, Paper } from "@mui/material";
import BlockIcon from '@mui/icons-material/Block';
import { adminTheme } from "theme/adminTheme";

interface Props {
  title: string;
  text?: string;
  waiting?: boolean; // new prop to determine the state
  IconComponent?: typeof BlockIcon; // new prop to pass the icon component
  children?: any;
}

export function InfoComponent({
  title,
  text,
  waiting = false,
  IconComponent = BlockIcon,
  children
}: Props) {
  const iconColor = waiting ? adminTheme.colors.primary : adminTheme.colors.error;
  const gradientBg = waiting
    ? `linear-gradient(135deg, ${adminTheme.colors.primary}20 0%, ${adminTheme.colors.primary}10 100%)`
    : `linear-gradient(135deg, ${adminTheme.colors.error}20 0%, ${adminTheme.colors.error}10 100%)`;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        p: 4,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 5,
          textAlign: "center",
          maxWidth: 600,
          bgcolor: adminTheme.colors.background,
          border: `1px solid ${adminTheme.colors.border}`,
          borderRadius: adminTheme.borderRadius.xl,
        }}
      >
        <Box
          sx={{
            width: 120,
            height: 120,
            borderRadius: "50%",
            background: gradientBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 3,
          }}
        >
          <Box
            component={IconComponent}
            sx={{
              fontSize: 64,
              color: iconColor,
            }}
          />
        </Box>

        <Typography
          variant="h5"
          gutterBottom
          sx={{
            textAlign: "center",
            fontWeight: 700,
            color: adminTheme.colors.textPrimary,
            mb: 2,
          }}
        >
          {title}
        </Typography>

        {text && (
          <Typography
            variant="body2"
            sx={{
              textAlign: "center",
              color: adminTheme.colors.textSecondary,
              lineHeight: 1.7,
              mb: children ? 3 : 0,
            }}
          >
            {text}
          </Typography>
        )}

        {children && <Box sx={{ mt: 3 }}>{children}</Box>}
      </Paper>
    </Box>
  );
}
